import { render, staticRenderFns } from "./YearClosing.vue?vue&type=template&id=46a21bd4"
import script from "./YearClosing.vue?vue&type=script&lang=js"
export * from "./YearClosing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports